import { Injectable, Inject } from '@angular/core';

import { TranslateService } from 'ng2-translate/ng2-translate';


import {AlertService} from "./alert/alert.service";
//import { ToastrService } from 'toastr-ng2';

declare var $:any;

@Injectable()
export class HttpHandlerService {


  constructor(public translate:TranslateService, public alertService:AlertService) {

  }

  public handleMessage(res:any) {
    if (res.headers) {
      let errorKey = res.headers.get('X-tikonApp-error');
      if (errorKey)
        this.alertService.showSuccessMessage(errorKey);

    }
  }

  public handle(error:any) {

    //bad request
    if (error.status == '400') {
      if (error.headers) {
        let errorKey = error.headers.get('X-tikonApp-error');

        if (errorKey)
          this.alertService.showErrorMessage(errorKey);

      }

    }
    else if (error.status == '500') {
      // this.alertService.showErrorMessage('error.InternalServerError');
    }
    else if(error.status == '0')
    {
      this.alertService.showErrorMessage('error.NO_CONNECTION_ERROR');
    }

    //if (error._body !=null && error._body.ModelState!=null) {
    //
    // //   var message:string = $.map(error._body.ModelState, (err:any) => err[0]);
    //
    // //   this.toastrService.error(this.translate.instant(message[0]), '');
    //    return true;
    //}
    return false;

  }
}




// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/httpHandler.service.ts